// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Loader } from '@livechat/design-system'
import { AuthProvider } from '../contexts/auth'
import useAuth from '../hooks/use-auth'
import Connected from '../components/Connected'

const loaderWrapperCss = css`
  display: flex;
  align-items: center;
  margin: 20px 0;
`

const Connection = () => {
  const auth = useAuth(undefined, undefined, undefined, 'token')
  const { isLoggingIn } = auth

  return (
    <AuthProvider value={auth}>
      <main
        css={css`
          display: flex;
          align-items: center;
          margin: 20px;
          width: 100%;
        `}
      >
        {isLoggingIn ? (
          <div
            css={css`
              display: flex;
              height: 100vh;
              width: 100%;
              align-items: center;
              justify-content: center;
            `}
          >
            <div css={loaderWrapperCss}>
              <Loader label="Loading..." size="medium" />
            </div>
          </div>
        ) : (
          <Connected />
        )}
      </main>
    </AuthProvider>
  )
}

export default Connection
